import { ReactNode } from "react";
import Footer from "../pages/landing/sections/Footer";
import TopBar from "../pages/landing/sections/TopBar";

const GuestLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div>
      <TopBar />
      {children}
      <Footer />
    </div>
  );
};

export default GuestLayout;
